import Skeleton from 'react-loading-skeleton'

export const SkeletonNegociation = () => (
  <div className="flex flex-col">
    <Skeleton height="184px" />
    <Skeleton height="400px" />
  </div>
)
